/*
  Fishing Stand
  by Kenney (https://poly.pizza/m/Li1cr0atPF)
    
  Auto-generated by: https://github.com/pmndrs/gltfjsx
*/
import { useGLTF } from '@react-three/drei'
import type { ObjectMap } from '@react-three/fiber'
import type { JSX } from 'react'
import type { Mesh, MeshStandardMaterial } from 'three'
import type { GLTF } from 'three-stdlib'

type GLTFResult = GLTF &
  ObjectMap & {
    nodes: {
      fishingStand: Mesh
    }
    materials: {
      wood: MeshStandardMaterial
    }
  }

export default function Stand(props: JSX.IntrinsicElements['group']) {
  const { nodes, materials } = useGLTF('./models/stand.glb') as GLTFResult

  return (
    <mesh
      {...props}
      dispose={null}
      castShadow
      receiveShadow
      geometry={nodes.fishingStand.geometry}
      material={materials.wood}
    />
  )
}

useGLTF.preload('./models/stand.glb')
